import { useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'
import { getGroups } from './getGroups'
import { GroupListItem } from '../types'

type Props = {
  tenantId?: string
}

export function useQueryGroups({ tenantId }: Props = {}) {
  return useQuery<GroupListItem[]>({
    queryKey: ['groups', tenantId],
    queryFn: () => getGroups(tenantId),
    staleTime: MINUTE_IN_MS * 5,
  })
}
